import { Box, GlobalStyles } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GlobalReset = () => (
  <GlobalStyles
    styles={{
      html: {
        margin: 0,
        padding: 0,
        height: "100%",
      },
      body: {
        margin: 0,
        padding: 0,
        height: "100%",
        overflow: "hidden",
      },
      "#root": {
        height: "100%",
      },
    }}
  />
);

export const OuterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100vw",
  height: "100vh",
  backgroundColor: "#1c1c1c",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "80%",
  height: "100%",
  backgroundColor: "transparent",
  flexDirection: "row-reverse",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

export const LeftPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "20px",
  textAlign: "center",
  boxSizing: "border-box",
  height: "700px",
  marginTop: 48,
  transform: "translate(-100px, 49px)",
  [theme.breakpoints.down("md")]: {
    transform: "none",
    marginBottom: "20px",
  },
}));

export const RightPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "40px",
  backgroundColor: "#fff",
  borderRadius: "20px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  maxWidth: "400px",
  height: "600px",
  margin: "auto 0",
  boxSizing: "border-box",
  [theme.breakpoints.down("md")]: {
    maxWidth: "90%",
    height: "auto",
    borderRadius: "10px",
    padding: "20px",
    alignItems: "center",
  },
}));
